import { Card, Typography, Empty } from "antd";
import { SmileOutlined } from "@ant-design/icons";
import React from "react";

export function EmptyFeedCard() {
  return (
    <Card
      style={{
        minHeight: 320,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        margin: "32px auto",
        width: "100%",
        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        borderRadius: 16,
        background: "#fafbfc",
      }}
    >
      <SmileOutlined
        style={{ fontSize: 48, color: "#bfbfbf", marginBottom: 16 }}
      />
      <Typography.Title
        level={3}
        style={{ marginBottom: 0, color: "var(--color-text-inverse-tertiary)" }}
      >
        Nothing to see here... yet!
      </Typography.Title>
      <Typography.Paragraph
        style={{
          color: "var(--color-text-inverse-tertiary)",
          marginTop: 8,
          marginBottom: 0,
        }}
      >
        Your feed is as empty as a Friday afternoon meeting.
        <br />
        Try adjusting your filters, or check back soon for fresh insights!
      </Typography.Paragraph>
      <Empty description={false} style={{ marginTop: 24 }} />
    </Card>
  );
}
